<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div id="mapCliente" />
          <div v-if="!enableTable">
            <v-icon
              id="iconDistribuicaoClientes"
              class="text-center"
              @click="exibirTabela()"
            >
              mdi-chevron-down-box
            </v-icon>
            Exibir legenda
          </div>
          <div v-else>
            <v-icon
              id="iconDistribuicaoClientes"
              class="text-center"
              @click="exibirTabela()"
            >
              mdi-chevron-up-box
            </v-icon>
            Recolher legenda
            <div
              id="idTable"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
                mobile-breakpoint="0"
              >
                <tbody>
                  <tr
                    v-for="item in clientesLegenda"
                    :key="item.id"
                  >
                    <td
                      id="dadoMovimentacao"
                      style="text-align: center;"
                    >
                      <v-chip
                        class="pa-2 rounded-circle"
                        :color="item.cor"
                        x-small
                        dark
                      />
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: left;"
                    >
                      {{ item.nome }}
                    </td>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: right;"
                    >
                      {{ item.porcentagem }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Cliente from '../../../../services/somentecliente'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardMapsCliente',
    data () {
      return {
        map: null,
        markers: [],
        center: {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        },
        marker: '',
        indiceLegenda: [],
        currentLocation: null,
        primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
        dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
        select: [],
        receita: [],
        segmento: [],
        classificacao: [],
        linhaProducao: [],
        cidades: [],
        cepGeocalizacao: [],
        window_open: false,
        info_marker: null,
        infowindow: '',
        locations: [],
        clientesLegenda: [],
        headersClientes: [
          { text: 'Cor', value: 'cor', align: 'right', class: 'black--text title' },
          { text: 'Nome', value: 'nome', align: 'left', class: 'black--text title', sytle: 'margin-left: -1rem' },
          { text: 'Quantidade', value: 'numero', align: 'right', class: 'black--text title' },
          { text: 'Porcentagem', value: 'porcentagem', align: 'right', class: 'black--text title' },
        ],
        corsLegend: [
          { corBackground: '#ea4335', corGlyph: '#b31412' },
          { corBackground: '#64B5F6', corGlyph: '#2196F3' },
          { corBackground: '#8D6E63', corGlyph: '#795548' },
          { corBackground: '#26A69A', corGlyph: '#009688' },
          { corBackground: '#C8E6C9', corGlyph: '#4CAF50' },
          { corBackground: '#FFF176', corGlyph: '#FBC02D' },
          { corBackground: '#FFB74D', corGlyph: '#FF9800' },
          { corBackground: '#EEEEEE', corGlyph: '#9E9E9E' },
          { corBackground: '#BA68C8', corGlyph: '#9C27B0' },
        ],
        styleObject: {
          color: localStorage.corPrimaria,
        },
        loading: false,
        error: null,
        enableTable: false,
        vendedores: [],
        area: [],
        rede: [],
        supervisor: [],
        categoria: [],
        promotor: [],
        clientes: [],
        zoom: 10,
      }
    },

    created () {
      eventEmit.$on('set-localizcao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-localizcao-cliente', this.handleUpdateDados)
    },

    mounted () {
      // Exemplo de uso da API do Google Maps
      const map = new window.google.maps.Map(document.getElementById('mapCliente'), {
        center: this.center,
        zoom: 14,
        mapId: '39ddaa6e92a6459f',
      })

      // eslint-disable-next-line no-unused-vars
      const markerView = new window.google.maps.marker.AdvancedMarkerView({
        map,
        position: this.center,
        title: this.center.name,
      })
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.vendedores = vendedores
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades
        this.clientes = clientes

        this.mapaInicial()

        this.atualizaGrafico()
      },

      mapaInicial () {
        this.clientesLegenda = []
        this.locations = []
        this.center = {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        }

        const map = new window.google.maps.Map(document.getElementById('mapCliente'), {
          center: this.center,
          zoom: 14,
          mapId: '720ea4b21b747745',
        })

        // eslint-disable-next-line no-unused-vars
        const markerView = new window.google.maps.marker.AdvancedMarkerView({
          map,
          position: this.center,
          title: this.center.name,
        })
      },

      async atualizaGrafico () {
        this.loading = true

        await Cliente.showClienteLocalizacao(this.primeiroDia, this.dataFinal, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades, this.clientes).then(resposta => {
          if (resposta.data.status) {
            this.clientesLegenda = resposta.data.legenda.map((item) => {
              var listaLegenda = ({
                nome: item.nome,
                numero: item.numero,
                porcentagem: item.porcentagem.toFixed(2) + '%',
                cor: this.corsLegend[item.codigo].corBackground,
              })

              return listaLegenda
            })

            this.locations = resposta.data.geoLocalizacao.map((item) => {
              var listaLocations = ({
                lat: item.latitude,
                lng: item.longitude,
                tooltip: item.nome_legenda,
                corBackground: this.corsLegend[item.codigo].corBackground,
                corGlyph: this.corsLegend[item.codigo].corGlyph,
              })

              return listaLocations
            })

            this.center = this.locations[0]

            this.setMarker()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      setMarker () {
        const contentCenter = { background: this.center.corBackground, glyphColor: this.center.corGlyph, borderColor: this.center.corBackground }

        const map = new window.google.maps.Map(document.getElementById('mapCliente'), {
          center: this.center,
          zoom: 12,
          mapId: '720ea4b21b747745',
          title: this.center.tooltip,
          content: contentCenter,
        })

        // Create an info window to share between markers.
        const infoWindow = new window.google.maps.InfoWindow()

        this.locations.forEach(location => {
          // Adicionar cor marcadores
          const pinViewBackground = new window.google.maps.marker.PinView({
            background: location.corBackground,
            glyphColor: location.corGlyph,
            borderColor: location.corBackground,
          })

          // Adicionar marcadores
          const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.tooltip,
            content: pinViewBackground.element,
          })

          marker.addListener('gmp-click', (event) => {
            infoWindow.close()
            infoWindow.setContent(marker.title)
            infoWindow.open(marker.map, marker)
          })

          this.markers.push(marker)
        })
      },

      exibirTabela () {
        if (this.enableTable) {
          this.enableTable = false
        } else {
          this.enableTable = true
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #map {
    height: 400px;
  }
</style>

<style>
  #mapCliente {
    height: 400px;
  }
</style>
